// Only an opaque, authenticated-API reference: never a card secret, credential,
// contact or OTP. Tab storage survives refresh, not a browser-wide account login.
const key = (flowId: string) => `bac:pending-checkout:${flowId}`;
const publicIdPattern = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
export function readPendingCheckout(flowId?: string | null): string | null {
  if (!flowId) return null;
  try {
    const value = sessionStorage.getItem(key(flowId));
    return value && publicIdPattern.test(value) ? value : null;
  } catch { return null; }
}
export function savePendingCheckout(flowId: string | null | undefined, publicId: string | null): void {
  if (!flowId) return;
  try {
    if (publicId === null) sessionStorage.removeItem(key(flowId));
    else if (publicIdPattern.test(publicId)) sessionStorage.setItem(key(flowId), publicId);
  } catch { /* The mounted checkout also retains its pending reference. */ }
}
